import { useState, useRef, useCallback, useEffect } from 'react';
import ReactDOM from 'react-dom';

const RightClickMenu = ({ tableElement, onPaste, onCopy, onCut, onUndo }) => {
  const [show, setShown] = useState(false);
  const [position, setPosition] = useState({ x: 0, y: 0 });

  const rightClickMenu = useRef(null);

  const handleRightClick = useCallback((e) => {
    e.preventDefault();
    setShown(true);
    setPosition({ x: e.pageX, y: e.pageY });
  }, []);

  const handleMouseDown = useCallback((e) => {
    if (e.button === 2) {
      e.preventDefault();
      return;
    }

    if (rightClickMenu.current) {
      if (rightClickMenu.current.contains(e.target)) {
        e.preventDefault();
        return;
      }
    }
    setShown(false);
  }, []);

  const handlePaste = useCallback(async () => {
    setShown(false);
    const text = await navigator.clipboard.readText();
    onPaste({ type: 'click-paste', text: text?.trim() });
  }, [onPaste]);

  const handleActionKeyDown = useCallback(
    (action) => (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        action();
      }
    },
    []
  );

  const handleCopy = useCallback(async () => {
    setShown(false);
    const text = onCopy();
    navigator.clipboard.writeText(text);
  }, [onCopy]);

  const handleCut = useCallback(async () => {
    setShown(false);
    const text = onCut();
    navigator.clipboard.writeText(text);
  }, [onCut]);

  useEffect(() => {
    if (!tableElement) return;
    tableElement.addEventListener('contextmenu', handleRightClick);
    document.addEventListener('mousedown', handleMouseDown);
    return () => {
      tableElement.removeEventListener('contextmenu', handleRightClick);
      document.removeEventListener('mousedown', handleMouseDown);
    };
  }, [tableElement, handleRightClick, handleMouseDown]);

  if (!show) return null;

  return ReactDOM.createPortal(
    <div
      className="right-click-menu"
      ref={rightClickMenu}
      style={{
        top: 0,
        left: 0,
        transform: `translate(${position.x}px, ${position.y}px)`,
        zIndex: 200,
      }}
      onContextMenu={(e) => e.preventDefault()}
    >
      <div
        role="button"
        tabIndex={0}
        onClick={handleCopy}
        onKeyDown={handleActionKeyDown(handleCopy)}
        className="right-click-menu-item"
      >
        Copy
      </div>
      <div
        role="button"
        tabIndex={0}
        onClick={handleCut}
        onKeyDown={handleActionKeyDown(handleCut)}
        className="right-click-menu-item"
      >
        Cut
      </div>
      <div
        role="button"
        tabIndex={0}
        onClick={handlePaste}
        onKeyDown={handleActionKeyDown(handlePaste)}
        className="right-click-menu-item"
      >
        Paste
      </div>
      <div
        role="button"
        tabIndex={0}
        onClick={onUndo}
        onKeyDown={handleActionKeyDown(onUndo)}
        className="right-click-menu-item"
      >
        Undo
      </div>
      <spacer />
      {/* PLACEHOLDER */}
      {/* <div onClick={() => setShown(false)}>Need Help?</div> */}
    </div>,
    document.body
  );
};

export default RightClickMenu;
